import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LANGS, langLink } from '../../../services/i18n-live';

/** 404 "wrong turn": the Night Drive road veers off and straightens while "Home" is hovered. */
@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrl: './error.component.css',
})
export class ErrorComponent {
  private readonly translate = inject(TranslateService);
  private readonly router = inject(Router);

  constructor() {
    // The '**' route has no :lang param, so a direct hit on a bad URL may arrive with no language
    // yet. The stored choice wins (the navbar applies it too), then a /en or /ru prefix, then am.
    if (!this.translate.currentLang) this.translate.use(this.storedLang() ?? this.urlLang() ?? 'am');
  }

  get homeLink(): string {
    return langLink(this.translate, '/');
  }

  private storedLang(): string | null {
    try {
      return asLang(localStorage.getItem('selectedLanguage'));
    } catch {
      return null;
    }
  }

  private urlLang(): string | null {
    return asLang(this.router.url.split(/[?#]/)[0].split('/').filter(Boolean)[0]);
  }
}

function asLang(value: string | null | undefined): string | null {
  return value && (LANGS as readonly string[]).includes(value) ? value : null;
}
